import request from '../utils/request';

// 获取所有自定义变量
export function getVariable() {
  return request({
    url: '/index/website/variable',
    method: 'get',
  });
}

// 根据标识获取指定自定义变量
export function getVariableInfo(params) {
  return request({
    url: '/index/website/variable/info',
    method: 'get',
    params,
  });
}
